module.exports = __webpack_public_path__ + "img/file-earmark-code.f557364b.svg";